import React, {useState} from "react";

import * as functionHelper from '../common/functions';

const ItemNamePartialComponent = ({item}) => {

  const uniqueSeries = functionHelper.getUniqueSeriesNames(item.series);
  return(
    <React.Fragment>
     <ul className="list-inline seriesList">
      {
        uniqueSeries.map((series, key) => {
          return (
            <React.Fragment key={key}>
              <li className="list-inline-item">{series}</li>
            </React.Fragment>
           );
        })
      }
      </ul>
      <strong>{item.name}</strong>     
    </React.Fragment>
  )

}
export default ItemNamePartialComponent;